var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconStats(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.356 12.507a3.9 3.9 0 1 0-2.83-1.216l-1.177 1.682a3.206 3.206 0 0 0-1.104-.195c-.661 0-1.275.2-1.786.542l-1.11-1.01a2.796 2.796 0 1 0-5.117.212l-3.488 3.864v2.908l5.01-5.385c.308.116.642.18.99.18.453 0 .881-.107 1.26-.299l1.219 1.108a3.212 3.212 0 1 0 5.699-.684l1.31-1.872c.355.107.733.165 1.124.165Zm0-2a1.9 1.9 0 1 0 0-3.8 1.9 1.9 0 0 0 0 3.8Zm-9.816.786a.796.796 0 1 1-1.592 0 .796.796 0 0 1 1.592 0Zm5.917 4.698a1.212 1.212 0 1 1-2.425 0 1.212 1.212 0 0 1 2.425 0Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStats);
export default __webpack_public_path__ + "static/media/icon-stats.22292cbb.svg";
export { ForwardRef as ReactComponent };